import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import AboutMe from '../components/sections/AboutMe';
import OpenSource from '../components/sections/OpenSourceProjects';
import Testimonial from '../components/sections/Testimonial';
import ContactForm from '../components/sections/ContactForm';

const Home = () => {

  return (
    <>
      <Hero className="illustration-section-01" />
      <FeaturesTiles />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <OpenSource invertMobile topDivider imageFill className="illustration-section-02" />
      <AboutMe invertMobile topDivider imageFill className="illustration-section-02" />
      <Testimonial topDivider />
      <ContactForm/>
    </>
  );
}

export default Home;
